export const applicationRoles = ['tank', 'heal', 'damage'] as const

type ApplicationRole = typeof applicationRoles[number]
export default ApplicationRole
